// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2eC7F","fileBtn":"File_fileBtn__3Rriu","closeBtn":"File_closeBtn__1XrVD","fileSelected":"File_fileSelected__fk1DF","disabled":"File_disabled__2muST"};